'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _formatName = require('../utils/formatName');

var _formatName2 = _interopRequireDefault(_formatName);

var _formatFriendlyName = require('../utils/formatFriendlyName');

var _formatFriendlyName2 = _interopRequireDefault(_formatFriendlyName);

var _TitleTypes = require('../constants/TitleTypes');

var _TitleTypes2 = _interopRequireDefault(_TitleTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _react2.default.createClass({
  displayName: 'FormattedName',

  propTypes: {
    email: _react.PropTypes.string,
    familyName: _react.PropTypes.string,
    givenName: _react.PropTypes.string,
    isFriendly: _react.PropTypes.bool,
    name: _react.PropTypes.string,
    options: _react.PropTypes.object,
    titleType: _react.PropTypes.oneOf(Object.keys(_TitleTypes2.default).map(function (title) {
      return _TitleTypes2.default[title];
    }))
  },

  getDefaultProps: function getDefaultProps() {
    return {
      isFriendly: false
    };
  },
  render: function render() {
    var _props = this.props,
        email = _props.email,
        familyName = _props.familyName,
        givenName = _props.givenName,
        isFriendly = _props.isFriendly,
        name = _props.name,
        options = _props.options,
        titleType = _props.titleType;

    var formattedName = isFriendly ? (0, _formatFriendlyName2.default)({ givenName: givenName, familyName: familyName, email: email }, options) : (0, _formatName2.default)({
      firstName: givenName,
      lastName: familyName,
      email: email,
      name: name,
      titleType: titleType
    }, options);
    return _react2.default.createElement(
      'span',
      null,
      formattedName
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/I18n/static-7.297/js/components/FormattedName.js
// module id = 341
// module chunks = 0